<!-- 设备操作记录  -->
<template>
  <div class="data-monitoring-container">
    <!-- 顶部标题栏 -->
    <div class="header-section">
      <div class="title-wrapper">
        <h2 class="page-title">桂枝岭水厂设备操作记录</h2>
      </div>
      <div class="action-wrapper">
        <a-select v-model="selectedPlant" style="width: 200px; margin-right: 16px;">
          <a-select-option value="guizhiling">桂枝岭水厂</a-select-option>
        </a-select>
        <a-button type="primary">
          <a-icon type="swap" /> 切换水厂
        </a-button>
      </div>
    </div>

    <a-card>
      <div class="table-page-search-wrapper">
        <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
          <a-row :gutter="48">
            <!-- 第一排 -->
            <a-col :md="6" :sm="12">
              <a-form-item label="所属区域">
                <a-select v-model="query.regionId" placeholder="请选择所属区域" allow-clear>
                  <template v-for="item in regionList">
                    <a-select-option :value="item.value">{{ item.name }}</a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="设备类型">
                <a-select v-model="query.equipmentType" placeholder="请选择设备类型" allow-clear>
                  <template v-for="item in equipmentTypeList">
                    <a-select-option :value="item.value">{{ item.name }}</a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="设备属性">
                <a-select v-model="query.processingStatus" placeholder="请选择设备属性" allow-clear>
                  <a-select-option :value="1">未处理</a-select-option>
                  <a-select-option :value="2">已处理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.deviceName" placeholder="请输入设备名称" allow-clear />
              </a-form-item>
            </a-col>
            <!-- 第二排-->
            <a-col :md="6" :sm="12">
              <a-form-item label="设备编码">
                <a-input v-model="query.deviceCode" placeholder="请输入设备编码" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="指令来源">
                <a-select v-model="query.instructionSource" placeholder="请选择指令来源" allow-clear>
                  <a-select-option :value="1">远程指令</a-select-option>
                  <a-select-option :value="2">人工操作</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 第三排-操作按钮 -->
            <a-col :md="24" :sm="24" :xs="24">
              <div style="margin-bottom: 20px;">
                <a-button type="primary" @click="queryList">查询</a-button>
                <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
                <a-button style="margin-left: 12px" @click="addOrUpdateHandle()">新增</a-button>
                <a-button style="margin-left: 12px" @click="deleteSelectRow()" type="danger">删除</a-button>
                <a-button style="margin-left: 12px" @click="exportHandle()" type="primary">导出</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table rowKey="id" :bordered="true"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
        :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange"
        :scroll="{ x: 1500 }">

      </a-table>


    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common' //选项式混合导入
import storage from 'store'

const columns = [ //表头参数
  {
    title: '所属水厂',
    dataIndex: 'aWaterWorks',
    width: '120px', // 固定操作列宽度
    fixed: 'left',
    ellipsis: true
  },
  {
    title: '所属工艺车间',
    dataIndex: 'userName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '设备类型',
    dataIndex: 'userAddress',
    width: '150px',
    ellipsis: true
  },
  {
    title: '设备名称',
    dataIndex: 'waterMeterNumber',
    width: '150px',
    ellipsis: true
  },
  {
    title: '设备编码',
    dataIndex: 'waterTypeName',
    width: '150px',
    ellipsis: true,
  },
  {
    title: '设备属性',
    dataIndex: 'alarmInstructions',
    width: '250px',
    ellipsis: true
  },
  {
    title: '操作前参数',
    dataIndex: 'previousUsage',
    width: '150px',
    ellipsis: true
  },
  {
    title: '操作后参数',
    dataIndex: 'lastIssueTime',
    width: '150px',
    ellipsis: true
  },
  {
    title: '操作人/账号',
    dataIndex: 'currentUsage',
    width: '150px',
    ellipsis: true
  },
  {
    title: '操作时间',
    dataIndex: 'currentGatherTime',
    width: '150px',
    ellipsis: true
  },
  {
    title: '指令来源',
    dataIndex: 'startTime',
    width: '150px',
    ellipsis: true
  },
  {
    title: '操作状态',
    dataIndex: 'processingStatus',
    width: '150px',
    ellipsis: true,
    scopedSlots: { customRender: 'processingStatus' }
  },
  {
    title: '操作IP地址',
    dataIndex: 'processingPersonnel',
    width: '150px',
    ellipsis: true
  },
  {
    title: '操作描述',
    dataIndex: 'processDescription',
    width: '150px',
    ellipsis: true
  },
]
const tenantIdStorage = storage.get('tenantId') //获取租户id

export default {
  mixins: [mixinViewModule],
  name: 'AllUserPage',
  data () {
    return {
      // 通用属性
      needQuery: false, // 是否在created就执行查询操作
      currentId: '',
      queryUrl: '', //查询url
      querySetting: '', //查询设置
      addOrUpdateUrl: '', //新增or编辑url
      deleteUrl: '', //删除url
      batchDisposeUrl: '', //批量处理url
      exportDataUrl: '', //导出url
      exportFileName: '', //导出名称
      query: {}, //查询对象
      columns,

      // 页面内属性
      selectedPlant: 'guizhiling', //所属水厂
      waterWorkList: [ //所属水厂列表
        { value: 1, name: '1#水厂' },
        { value: 2, name: '2#水厂' },
        { value: 3, name: '3#水厂' },
      ],
      regionList: [ //所属区域列表
        { value: 1, name: '1#区域', },
        { value: 2, name: '2#区域', },
        { value: 3, name: '3#区域', },
      ],
      equipmentTypeList: [ //设备类型列表
        { value: 1, name: '阀门' },
        { value: 2, name: '水表' },
        { value: 3, name: '其他' },
      ],
    }
  },
  created () {

  },
  methods: {
    // 重置
    resetList () {
      this.query = {}
    },
    // 所属区域变化
    onRegionChange (value) {
      this.query.regionId = value[value.length - 1]
    },
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 16px 24px;
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
}

/deep/.ant-card {
  border-radius: 4px;
}

/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.proportion {
  font-size: 15px;
  font-weight: bold;
  display: block;
  margin-bottom: 20px;
}
</style>
